import { forwardRef } from 'react';
import { Vector3 } from 'three';

import {
  Furniture as BaseFurniture,
  FurnitureProps as BaseFurnitureProps,
} from '@spazious/dollhouse-engine';
import { Instance } from '@spazious/dollhouse-three';
import { useForkRef } from '@spazious/react-hooks';

import { useFloorPosition } from '../../hooks/index.js';

export interface FurnitureProps extends Omit<BaseFurnitureProps, 'position'> {
  position: Parameters<Vector3['set']>;
}

export const Furniture = forwardRef<Instance, FurnitureProps>(({ position, ...restProps }, ref) => {
  const { floorPosition, nodeRef } = useFloorPosition(position);
  const forkedRef = useForkRef(ref, nodeRef);

  return <BaseFurniture ref={forkedRef} position={floorPosition} {...restProps} />;
});
